import React, { useState } from "react";

import { FormControlLabel, Switch } from "@material-ui/core";

type Props = {
  active: number;
  id: number;
  setStatus: (id: number, is_active: boolean) => void;
};

const Component: React.FunctionComponent<Props> = ({
  active,
  id,
  setStatus
}) => {
  const [isActive, setIsActive] = useState(active ? true : false);

  return (
    <FormControlLabel
      control={
        <Switch
          checked={isActive}
          onChange={event => {
            setIsActive(event.target.checked);
            setStatus(id, event.target.checked);
          }}
          name="is_active"
          color="primary"
        />
      }
      label={isActive ? "Active" : "Inactive"}
    />
  );
};

export default Component;
